{
  "RESET_PASSWORD": {
    "TITLE": "Zresetuj hasło",
    "DESCRIPTION": "Enter the email address you use to log in to Chatwoot to get the password reset instructions.",
    "GO_BACK_TO_LOGIN": "If you want to go back to the login page,",
    "EMAIL": {
      "LABEL": "E-mail",
      "PLACEHOLDER": "Wprowadź swój adres e-mail.",
      "ERROR": "Wprowadź poprawny adres e-mail."
    },
    "API": {
      "SUCCESS_MESSAGE": "Link do resetowania hasła został wysłany na Twój adres e-mail.",
      "ERROR_MESSAGE": "Nie można połączyć się z serwerem Woot. Spróbuj ponownie."
    },
    "SUBMIT": "Prześlij"
  }
}
